import { create } from "zustand";

export const useAuthStore = create((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
}));

export const useDeviceStore = create((set) => ({
  selectedDeviceId: null,
  setSelectedDevice: (id) => set({ selectedDeviceId: id }),
  liveReadings: {}, // deviceId -> latest reading
  updateLiveReading: (deviceId, reading) =>
    set((state) => ({
      liveReadings: { ...state.liveReadings, [deviceId]: reading },
    })),
}));
